import { CalendarItemTypeTypeEx } from 'owa-calendar-types/lib/types/CalendarEvent';
import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';
import EmailReminderSendOption from 'owa-service/lib/contract/EmailReminderSendOption';
import InboxReminderType from 'owa-service/lib/contract/InboxReminderType';
import { action } from 'satcheljs';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const setDraftInboxReminder = action(
    'setDraftInboxReminder',
    (inboxReminder: InboxReminderType) => ({
        inboxReminder,
    })
);

export const addNewEmailReminder = action(
    'addNewEmailReminder',
    (
        isAllDay: boolean,
        isOrganizerReminder: boolean,
        calendarItemType: CalendarItemTypeTypeEx
    ) => ({
        isAllDay,
        isOrganizerReminder,
        calendarItemType,
    })
);

export const editInboxReminder = action(
    'editInboxReminder',
    (inboxReminder: InboxReminderType, calendarItemType: CalendarItemTypeTypeEx) => ({
        inboxReminder,
        calendarItemType,
    })
);

export const onAddCustomReminderClicked = action('onAddCustomReminderClicked');

export const setDraftInboxReminderOffset = action(
    'setDraftInboxReminderOffset',
    (reminderOffset: number) => ({
        reminderOffset,
    })
);

export const setDraftInboxReminderSendOption = action(
    'setDraftInboxReminderSendOption',
    (sendOption: EmailReminderSendOption) => ({
        sendOption,
    })
);

export const setDraftInboxReminderMessage = action(
    'setDraftInboxReminderMessage',
    (message: string) => ({
        message,
    })
);

export const saveDraftInboxReminder = action(
    'saveDraftInboxReminder',
    (event: CalendarEvent, entrySource: EmailReminderEntrySource) => ({
        event,
        entrySource,
    })
);

export const discardDraftInboxReminder = action('discardDraftInboxReminder');
